import { UseIsMobile } from "common/hooks/UseIsMobile"
import DesktopSetTwoFactor from "./desktop"
import MobileSetTwoFactor from "./mobile"


const SetTwoFactor = () => {
    const mobile = UseIsMobile()

    return (
        <div>
            {
                mobile ?
                    <div className="block md:hidden">
                        <MobileSetTwoFactor />
                    </div>
                    :
                    <div className="hidden md:block">
                        <DesktopSetTwoFactor />
                    </div>
            }
        </div>
    )
}

export default SetTwoFactor
